export interface DecodedToken {
  username?: string;
  mobileNumber?: string;
  email?: string;
  exp?: number;
  iat?: number;
  [key: string]: any;
}

export const decodeToken = (token: string): DecodedToken | null => {
  try {
    // JWT tokens have 3 parts separated by dots
    const parts = token.split('.');
    if (parts.length !== 3) {
      console.warn('Invalid JWT token format');
      return null;
    }

    // Decode the payload (second part)
    const payload = parts[1];
    const decodedPayload = atob(payload);
    const parsedPayload = JSON.parse(decodedPayload);

    console.log('🔍 Decoded token payload:', parsedPayload);
    return parsedPayload;
  } catch (error) {
    console.error('Error decoding JWT token:', error);
    return null;
  }
};

export const extractUserInfoFromToken = (token: string) => {
  const decoded = decodeToken(token);
  if (!decoded) {
    return {
      username: null,
      mobileNumber: null,
      email: null
    };
  }

  return {
    username: decoded.username || decoded.sub || decoded.name || null,
    mobileNumber: decoded.mobileNumber || decoded.phone_number || decoded.phone || null,
    email: decoded.email || null
  };
};

export const isTokenExpired = (token: string): boolean => {
  const decoded = decodeToken(token);
  if (!decoded || !decoded.exp) {
    return true;
  }

  const currentTime = Math.floor(Date.now() / 1000);
  return decoded.exp < currentTime;
};

